export default {
  namespaced: true,
  state: {
    plans: [],
    count: 0,
  },
  getters: {
    plans: (state) => state.plans,
    count: (state) => state.count,
  },
  mutations: {
    plans: (state, payload) => (state.plans = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/v2/stripe/plans", {
          params: queryParams,
        })
        .then((res) => {
          commit("plans", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("/v2/stripe/plans", payload);
    },
    show({}, id) {
      return this.$apiService.get(`/v2/stripe/plans/${id}`);
    },
    update({}, { id, data }) {
      return this.$apiService.put(`/v2/stripe/plans/${id}`, data);
    },
    destroy({}, id) {
      return this.$apiService.delete(`/v2/stripe/plans/${id}`);
    },
    toggleActive({}, id) {
      return this.$apiService.get(`/v2/stripe/plans/${id}/toggle-active`);
    },
    createPrice({}, payload) {
      return this.$apiService.post("/v2/stripe/plans/price", payload);
    },
    destroyPrice({}, id) {
      return this.$apiService.get(`/v2/stripe/plans/price/${id}`);
    },
  },
};
